export default __webpack_public_path__ + "static/media/idea.35a8a052.svg";